export class ColumnChartModel {
  public data: number[];
  public type = undefined;
  public name: string;
  public stack = '';
  public color: string;
}
